/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=04e8d96a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/service-h5_Nxs7/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__